import { render, staticRenderFns } from "./player-control.vue?vue&type=template&id=32150e70&scoped=true&"
import script from "./player-control.vue?vue&type=script&lang=js&"
export * from "./player-control.vue?vue&type=script&lang=js&"
import style0 from "./player-control.vue?vue&type=style&index=0&id=32150e70&prod&lang=scss&scoped=true&"
import style1 from "./player-control.vue?vue&type=style&index=1&id=32150e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32150e70",
  null
  
)

export default component.exports